import { Inject, Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractJobAggregationService, AbstractJobService } from '@y42/job';
import { DatasourceTableJobServiceInjectionToken } from './datasource-table-job-service.injection-token';

@Injectable({
  providedIn: 'root',
})
export class DatasourceTableJobAggregationService extends AbstractJobAggregationService {
  constructor(
    @Inject(DatasourceTableJobServiceInjectionToken) jobServices: AbstractJobService[],
    errorHandlerService: ErrorHandlerService,
  ) {
    super(jobServices, errorHandlerService);
  }
}
